import axiosInstance from "../api.axiosInstance"
import type {
  ExtendedWarrantySnapshotDto,
  UpdateExtendedWarrantyDto,
} from "../dto/extended-warranty.dto"

export class ExtendedWarrantyService {
  public async updateSelection(
    proposalId: string,
    designId: string,
    body: UpdateExtendedWarrantyDto,
  ): Promise<ExtendedWarrantySnapshotDto> {
    const response = await axiosInstance.put<ExtendedWarrantySnapshotDto>(
      `/proposal/v1/${proposalId}/designs/${designId}/extended-warranty`,
      body,
    )

    return response.data
  }
}

export const extendedWarrantyService = new ExtendedWarrantyService()
